module.exports = __webpack_public_path__ + "static/img/yk9300.a7bd443.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hardware/yk9300.png
// module id = Pboc
// module chunks = 1